export { RequestCookies, ResponseCookies } from "next/dist/compiled/@edge-runtime/cookies";

//# sourceMappingURL=cookies.js.map